import { useController } from 'react-hook-form';
import { CalendarInput } from '@nexelem/components';
import { DateBadge, DateBadges } from './DateBadges';

export type DateFormInputProps = {
  name: string;
  label?: string;
  required?: boolean;
  badges?: DateBadge[];
  size?: 'small' | 'default' | 'jumbo' | 'extraJumbo';
  disabled?: boolean;
  helperText?: string;
  showErrorMessage?: boolean;
  className?: string;
  autoComplete?: string;
};

export const FormCalendarInput = ({
  badges,
  showErrorMessage = true,
  name,
  autoComplete = 'off',
  ...props
}: DateFormInputProps) => {
  const {
    field: { onChange, value, ...field },
    fieldState,
  } = useController({ name });

  const errorMessage = showErrorMessage ? fieldState.error?.message : undefined;
  const showErrorBorder = !!fieldState.error?.message;

  return (
    <>
      <CalendarInput
        autoComplete={autoComplete}
        errorMessage={errorMessage}
        mode="single"
        selected={value}
        showErrorBorder={showErrorBorder}
        onSelect={onChange}
        {...props}
        {...field}
      />
      {badges && <DateBadges badges={badges} onChange={onChange} />}
    </>
  );
};
